/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_No_Open_IssuesInputs */

const en_admin_dashboard_no_open_issues = /** @type {(inputs: Admin_Dashboard_No_Open_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything’s running smoothly 🎉`)
};

const de_admin_dashboard_no_open_issues = /** @type {(inputs: Admin_Dashboard_No_Open_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles läuft reibungslos 🎉`)
};

const es_admin_dashboard_no_open_issues = /** @type {(inputs: Admin_Dashboard_No_Open_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo funciona sin problemas 🎉`)
};

const fr_admin_dashboard_no_open_issues = /** @type {(inputs: Admin_Dashboard_No_Open_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout se passe bien 🎉`)
};

const nl_admin_dashboard_no_open_issues = /** @type {(inputs: Admin_Dashboard_No_Open_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles loopt soepel 🎉`)
};

const it_admin_dashboard_no_open_issues = /** @type {(inputs: Admin_Dashboard_No_Open_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto funziona alla perfezione 🎉`)
};

const pt_br2_admin_dashboard_no_open_issues = /** @type {(inputs: Admin_Dashboard_No_Open_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo funcionando perfeitamente 🎉`)
};

const pl_admin_dashboard_no_open_issues = /** @type {(inputs: Admin_Dashboard_No_Open_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystko działa sprawnie 🎉`)
};

const hu_admin_dashboard_no_open_issues = /** @type {(inputs: Admin_Dashboard_No_Open_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden rendben működik 🎉`)
};

const ro_admin_dashboard_no_open_issues = /** @type {(inputs: Admin_Dashboard_No_Open_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totul merge bine 🎉`)
};

/**
* | output |
* | --- |
* | "Everything’s running smoothly 🎉" |
*
* @param {Admin_Dashboard_No_Open_IssuesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_no_open_issues = /** @type {((inputs?: Admin_Dashboard_No_Open_IssuesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_No_Open_IssuesInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_no_open_issues(inputs)
	if (locale === "de") return de_admin_dashboard_no_open_issues(inputs)
	if (locale === "es") return es_admin_dashboard_no_open_issues(inputs)
	if (locale === "fr") return fr_admin_dashboard_no_open_issues(inputs)
	if (locale === "nl") return nl_admin_dashboard_no_open_issues(inputs)
	if (locale === "it") return it_admin_dashboard_no_open_issues(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_no_open_issues(inputs)
	if (locale === "pl") return pl_admin_dashboard_no_open_issues(inputs)
	if (locale === "hu") return hu_admin_dashboard_no_open_issues(inputs)
	return ro_admin_dashboard_no_open_issues(inputs)
});
export { admin_dashboard_no_open_issues as "admin.dashboard.no_open_issues" }